<div class="card">
  <div class="card-body d-flex flex-center flex-column py-9 px-5">
    <div class="symbol symbol-65px symbol-circle mb-5">
      @if (event.image_url && event.image_url.length > 0) {
        <img src="{{event.image_url}}" alt="image"/>
      } @else {
        <img src="assets/images/horse_placeholder.png" alt="image" />
      }
    </div>
    <a href="#" class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">{{event.event_name}}</a>
    <div class="fw-semibold text-gray-500 mb-6">{{ event.event_type?.event_type_name }}</div>
    <div class="d-flex flex-center flex-wrap mb-5">
      <div class="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
        <div class="fs-6 fw-bold text-gray-700">{{ event.city }}</div>
        <div class="fw-semibold text-gray-500">City</div>
      </div>
      <div class="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
        <div class="fs-6 fw-bold text-gray-700">{{ formatTimeDMYHHMM(event.start_date!) }}</div>
        <div class="fw-semibold text-gray-500">Date</div>
      </div>
    </div>
    <div class="button-container d-flex flex-row">
      <app-button
        [label]="'Manage event'"
        [variant]="'primary'"
        [iconClass]="'fa fa-edit'"
        class="me-2"
        (clicked)="navigateToManageEvent(event.event_id)"
      />
      <app-button
        [label]="'View event'"
        [variant]="'outline'"
        [iconClass]="'fa fa-eye'"
        class="me-2"

      />

    </div>
  </div>
</div>
